// App.js
import React from "react";
import "./App.css";
import "./fonts.css";
import Search from "./components/Search";
import Header from "./components/header";
import BottomNav from "./components/bottomNav"; // Import BottomNav component
import SearchV2 from "./components/SearchV2/SearchV2";
import PageLayout from "./components/PageLayout";

function App() {
  return (
    <div className="App">
      <PageLayout>
        <SearchV2 />
      </PageLayout>
    </div>
  );
}

export default App;
